import { isShiftingJourney } from 'common/constants/app.constants';
import { USER_TYPE, HARDWARE_TYPE } from 'home/view/upgrade-order/constants';

// base selectors
const getContractPeriod = (lead) => lead && lead.contractPeriod;

const getEligibleForRenewContract = (lead) => lead && lead.eligibleForRenewContract;

const getCustomerDetail = (lead) => lead && lead.customer;

const getLeadId = (lead) => lead && lead.leadId;

const getLeadStatus = (lead) => lead && lead.leadStatus;

const getLeadSegment = (lead) => lead && lead.channel;

const getDoaStatus = (lead) => lead && lead.doaStatus;

const getDoaAssignedToRole = (lead) => lead?.doaAssignedToRole;

const getDoaAssignedToUsers = (lead) => lead?.doaAssignedToUsers?.[0];

const getOrderSubType = (lead) => lead && lead.orderSubType;

const getOrderType = (lead) => lead && lead.orderType;

const getPartyId = (lead) => lead && lead.partyId;

const getSource = (lead) => lead && lead.source;

const getLineItemDetail = (lead) => lead && lead.lineItems && lead.lineItems[0];

const getJourneyInitiators = (lead) => lead && lead.initiators;

// derived selectors

const getKamDetails = (lead) => getJourneyInitiators(lead) && getJourneyInitiators(lead).find((item) => item.type === USER_TYPE.KAM); // {firstName, lastName, email, phoneNumber}

const getCompanyName = (lead) => getCustomerDetail(lead) && getCustomerDetail(lead).name;

const getCompanyAddress = (lead) => {
  const customerAddressList = (getCustomerDetail(lead) && getCustomerDetail(lead).addresses && getCustomerDetail(lead).addresses.find((item) => item.type === 'COMPANY')) || {};

  if (!customerAddressList) {
    return '';
  }

  const { line1 = '', line2 = '', city = '', state = '', pincode = '' } = customerAddressList;
  return `${line1} ${line1 && ', '} ${line2} ${line2 && ', '} ${city} ${city && ', '} ${state} ${state && ', '} ${pincode}`;
};

const getCustomerContactList = (lead) => getCustomerDetail(lead) && getCustomerDetail(lead).customerContacts;

const getOldLineItemDetail = (lead) => getLineItemDetail(lead) && getLineItemDetail(lead).oldLineItemDetail;

const getProductName = (lead) => getLineItemDetail(lead) && getLineItemDetail(lead).productName;

const getServiceType = (lead) => getLineItemDetail(lead) && getLineItemDetail(lead).subProductName;

const getPlanDetail = (lead) => getLineItemDetail(lead) && getLineItemDetail(lead).plan;

const getCurrentBw = (lead) => {
  const bw = getPlanDetail(lead) && getPlanDetail(lead).bandwidth;
  const splitBw = bw && bw.split(' ');
  return {
    value: (splitBw && splitBw[0]) || '',
    unit: (splitBw && splitBw[1]) || ''
  };
};

const getPlanPrice = (lead) => getPlanDetail(lead) && getPlanDetail(lead).price; // rental, oneTimeCharge

const getSiteDetail = (lead) => getPlanDetail(lead) && getPlanDetail(lead).site[0];

const getLsiId = (lead) => getSiteDetail(lead) && getSiteDetail(lead).lsiId;

const getSiteIncharge = (lead) => getSiteDetail(lead) && getSiteDetail(lead).siteIncharge; // name, phoneNumber

const getInstallationAddress = (lead) => {
  if (isShiftingJourney()) {
    const oldLineItemDetails = getOldLineItemDetail(lead);
    const addressString = oldLineItemDetails?.address?.line1 ?? '';

    return addressString;
  }

  const siteAddress = (getSiteDetail(lead) && getSiteDetail(lead).address) || {};

  if (!siteAddress) {
    return '';
  }

  const { line1 = '', line2 = '', city = '', state = '', pincode = '' } = siteAddress;

  return `${line1} ${line1 && ', '} ${line2} ${line2 && ', '} ${city} ${city && ', '} ${state} ${state && ', '} ${pincode}`;
};

const getFeasibilityResponse = (lead) => getSiteDetail(lead) && getSiteDetail(lead).feasibilityResponse; //feasibilityId, feasibilityStatus, requestedBandwidth, maxBandwidth, cbftTaskId

const getSiteSpecs = (lead) => getSiteDetail(lead) && getSiteDetail(lead).siteSpecs;

const getMediaType = (lead) => getSiteSpecs(lead) && getSiteSpecs(lead).find((item) => item.name === 'media');

const getEligibleMediaType = (lead) => getSiteDetail(lead) && getSiteDetail(lead).eligibleMedia;

const getCpeSpecification = (lead) => getSiteSpecs(lead) && getSiteSpecs(lead).find((item) => item.name === 'cpeSpecification');

const getHardwareType = (lead) => {
  const cpeSpecItem = getCpeSpecification(lead);

  if (cpeSpecItem) {
    return !cpeSpecItem.commercial ? HARDWARE_TYPE.STANDARD : HARDWARE_TYPE.NON_STANDARD;
  }

  return HARDWARE_TYPE.STANDARD;
};

const getInterface = (lead) => getSiteSpecs(lead) && getSiteSpecs(lead).find((item) => item.name === 'interface');

const getAnnualRecurringCharge = (lead) => getPlanPrice(lead) && getPlanPrice(lead).rental;

const getSpecs = (lead) => getPlanDetail(lead) && Array.isArray(getPlanDetail(lead).specs) && getPlanDetail(lead).specs.length > 0 && getPlanDetail(lead).specs[0];

export {
  getLeadStatus,
  getCustomerDetail,
  getEligibleForRenewContract,
  getLeadId,
  getContractPeriod,
  getServiceType,
  getLeadSegment,
  getCompanyName,
  getCompanyAddress,
  getMediaType,
  getProductName,
  getInstallationAddress,
  getAnnualRecurringCharge,
  getCurrentBw,
  getSpecs,
  getInterface,
  getCpeSpecification,
  getFeasibilityResponse,
  getSiteIncharge,
  getLsiId,
  getOldLineItemDetail,
  getCustomerContactList,
  getKamDetails,
  getHardwareType,
  getSource,
  getPartyId,
  getOrderSubType,
  getOrderType,
  getPlanPrice,
  getEligibleMediaType,
  getPlanDetail,
  getDoaStatus,
  getDoaAssignedToRole,
  getDoaAssignedToUsers
};
